import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Utils } from "../../../../Common/Utilis";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { isDatasetsDataEmpty } from "../../Data/options";
import NoSubscription from "../NoSubscription";
import { OverlayTrigger, Tooltip as ReactBootstrapTooltip } from "react-bootstrap";

ChartJS.register(ArcElement, Tooltip, Legend);

const ProgressChart = ({
  budget = 0,
  actual = 0,
  chartTitle,
  formatType,
  chartComparison,
  layoutItem,
  noSubscription,
  metric,
  showTimePeriod,
  DateRange,
  periodValue
}) => {
  const aspectRatio=layoutItem ? layoutItem?.w/layoutItem.cols : 1
  const percentage: any = budget === 0 
  ? 0 
  : Math.abs((Number(actual.toFixed(2)) / Number(budget.toFixed(2))) * 100);

  const cappedPercentage = Math.min(100, percentage);
  const difference =  Number(actual.toFixed(2)) - Number(budget.toFixed(2));

  // Format to 2 decimal places only if it's not a whole number
  const formattedPercentage =
  percentage % 1 === 0 || percentage.toFixed(2).endsWith('.00')
    ? Math.round(percentage).toString() // Convert to an integer
    : percentage.toFixed(2);

  const budgetvalue =
    formatType == "currency"
      ? Utils.currencyFormat(Number(budget || 0).toFixed(2))
      : formatType == "percentage"
      ? `${budget}%`
      : Utils.currencyFormatWithOutdoller(Number(budget).toFixed(0)).replace(".00", "");

  const actualvalue =
    formatType == "currency"
      ? Utils.currencyFormat(Number(actual || 0).toFixed(2))
      : formatType == "percentage"
      ? `${actual}%`
      : Utils.currencyFormatWithOutdoller(Number(actual).toFixed(0)).replace(".00", "");

 
  let differencevalue =
    formatType == "currency"
      ? Utils.currencyFormat(Number(difference || 0).toFixed(2))
      : formatType == "percentage"
      ? `${Number(difference || 0).toFixed(2)}%`
      : Utils.currencyFormatWithOutdoller(Number(difference).toFixed(0)).replace(".00", "");

  differencevalue = difference >0 ? `+${differencevalue}` :differencevalue

  const data = {
    datasets: [
      {
        data: [cappedPercentage, 100 - cappedPercentage],
        backgroundColor: ["#065A8C", "transparent"],
        borderWidth: 0,
        cutout: "70%", // Controls the thickness of the donut,
        borderRadius:{
          outerEnd: cappedPercentage == 100 ? 0 :60,
          innerEnd : cappedPercentage == 100 ? 0 :60,
        },
      },
    ],
  };

  const backgroundData = {
    datasets: [
      {
        data: [100],
        backgroundColor: ["#E5F5FF"],
        borderWidth: 0,
        cutout: "88%", // Controls the thickness of the donut
      },
    ],
  };

  const options = {
    // borderRadius: 60,
   
    rotation: -180, // Start angle for the speedometer effect
    // circumference: 270, // Only show half the circle
    // cutout: "70%",
    plugins: {
      tooltip: { enabled: false },
    },
    // responsive: true,
    // maintainAspectRatio: true,
  };

  let FromDate, ToDate;
  if (showTimePeriod) {
    ({ FromDate, ToDate } = DateRange || {});
  }

  const PeriodType =
    periodValue == 5 ? "YTD" : periodValue == 4 ? "Trailing 12" : periodValue == 1 ? "Current Period" :null


  return (
    <div className={`progress-chart-metric chart-metric ${aspectRatio < 0.4 ? "view-1-3" : ""}`}>
        <div>
        {/* <div className="d-one">{JSON.stringify(aspectRatio)}</div> */}
        <h3 className="chart-heading" style={{ whiteSpace: "pre-wrap" , }}>
          <div className="d-flex">
            <EllipsisWithTooltip placement="top">{chartTitle}</EllipsisWithTooltip>
            {showTimePeriod && <span className="badge">{`Showing ${PeriodType} ${FromDate} - ${ToDate}`}
              <span>
              <OverlayTrigger
                placement="top"
                delay={{ show: 100, hide: 200 }}
                overlay={
                  <ReactBootstrapTooltip id={"chartInfo"}>
                    This Data can only be shown on a month by month basis
                  </ReactBootstrapTooltip>
                }>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"></path><path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z"></path><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"></path></svg>
                  </OverlayTrigger>
              </span>  
            </span>}
          </div>
        </h3>
      {noSubscription ? <NoSubscription  isNoHidsSelected={noSubscription == 2} subscription={metric?.moduleNames}/> : 
        <div className="chart-wrapper col-md-8">
          {/* Left Side Labels */}
          <div className="chart-description" style={{ paddingRight: `${aspectRatio*50}px`}}>
            {/* <h3>Widget Title</h3> */}
            {chartComparison?.length > 0 && (
              <div style={{ marginBottom: "10px" }}>
                <span>{chartComparison[0]?.value}</span> 
                <h5 className={`card-text ${budgetvalue.length > 12 ? "set-size" : ""}`} 
                // style={{fontSize:`${aspectRatio*80}px`, lineHeight: `${aspectRatio*50}px`}}
                
                >{budgetvalue}</h5> 
              
              </div>
            )}
            <div className="actual-value" style={{ marginBottom: "10px" }}>
              <span>Actual</span> 
              <h5 className={`card-text ${actualvalue.length > 12 ? "set-size" : ""}`} 
              // style={{fontSize:`${aspectRatio*80}px`, lineHeight: `${aspectRatio*50}px`}}
              >{actualvalue}</h5> 
            </div>
          {chartComparison?.length > 0 &&  <div className="value-difference">
              <span>Difference</span> 
              <h5 className={`card-text ${differencevalue.length > 12 ? "set-size" : ""}`} 
              // style={{fontSize:`${aspectRatio*80}px`, lineHeight: `${aspectRatio*50}px`}}
              >{differencevalue}</h5> 
             
            </div>}
          </div>

          {/* Donut Chart */}
          <div className="chart" style={{ position: "relative", width: aspectRatio <= 0.4 ? "145px" : "250px", height: aspectRatio == 0.33333 ? "170px" : "250px" }}>
            <Doughnut
              data={backgroundData}
              options={{ ...options, 
                // circumference: 270, 
                radius: aspectRatio <= 0.4 ? 65 : 110 }}
              key={aspectRatio + "outer"}
            />

            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            >
              <Doughnut data={data} options={options} key={aspectRatio + "inner"} />
            </div>

            {/* Percentage Text in Center */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                fontSize: "20px",
                color: "#065A8C",
              }}
              className={aspectRatio <= 0.4 ? "pt-4" : ""}
            >
              <div className="d-block">
                <div style={{ fontSize: "12px", color: "#555" }}>Progress</div>
                <div className="progress-count" style={{ fontWeight: "bold", fontSize: "30px", lineHeight: "30px" }}>
                  {formattedPercentage}%
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div> 
    
    </div>
  );
};

export default React.memo(ProgressChart);
